import {CompanyRole} from "../../const/company-role"

const debug = false
// const debug = "AccessControl_Company"

export default class AccessControl_Company {


    isAdmin() {
        if (gd.companyId){
            return gd.session.companies.get(gd.companyId).isAdmin;
        }
        return false;
    }

    isManager(companyId = gd.companyId) {

        // nu esli chestno tut vsegda gd.comapnyId
        if (!companyId) companyId = gd.companyId;

        let res = false;
        if (companyId){

            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, gd.session.me.id);

            debug && console.log(debug, 'isManager companyUser', companyUser)

            if (companyUser && companyUser.companyRole === gd.const.companyRole.MANAGER ) {
                res = true;
            }
        }

        debug && console.log(debug, 'isManager', res)

        return res;
    }

    isUser(companyId:ID=gd.companyId) {
        let res = false;
        if (companyId){
            const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, gd.session.me.id);
            if (companyUser && companyUser.companyRole >= gd.const.companyRole.USER ) {
                return true
            }
        }

        return res;
    }

    isFullAccess(userId:ID, companyId = gd.companyId) {
        if (!userId) return false;

        let res;
        const company = gd.session.companies.get(gd.companyId);
        const companyUser = gd.session.companyUsers.findByCompanyAndUser(companyId, userId);

        switch (company.settings.defaultAccess) {
            case gd.const.company.defaultAccess.ADMIN:      res = companyUser && companyUser.isAdmin; break;
            case gd.const.company.defaultAccess.MANAGER:    res = companyUser && companyUser.companyRole >= gd.const.companyRole.MANAGER; break
            case gd.const.company.defaultAccess.NONE:
            default:                                        res = false; break;
        }

        return res;
    }

    // this is a copy of can add company users... refactoring needed
    canInviteUsers() {
        let res = false;
        if (gd.companyId) {

            const companyUser = gd.session.companyUsers.findByCompanyAndUser(gd.companyId, gd.session.me.id);

            if (companyUser && companyUser.companyRole === gd.const.companyRole.MANAGER ) {
                res = true;
            }
        }

        return res;
    }

    canCreateChat() {

        if (!gd.modules.chats.enabled) return false

        const companyRole = gd.session.companies.get(gd.companyId).role;
        return [gd.const.company.role.MANAGER, gd.const.company.role.USER].includes(companyRole);
    }

    canCreateDiscussion() {

        if (!gd.modules.chats.enabled) return false

        const companyRole = gd.session.companies.get(gd.companyId).role;
        return [gd.const.company.role.MANAGER, gd.const.company.role.USER, gd.const.company.role.CLIENT].includes(companyRole);
    }

    // this is a copy of can add company users... refactoring needed
    canCreateTag() {
        const companyRole = gd.session.companies.get(gd.companyId).role;
        return [gd.const.company.role.MANAGER, gd.const.company.role.USER].includes(companyRole);
    }

    canSeeCompanyUsers() {
        const companyRole = gd.session.companies.get(gd.companyId).role;
        return [gd.const.company.role.MANAGER, gd.const.company.role.USER].includes(companyRole);
    }

    canAddCustomers() {
        return [gd.const.company.role.MANAGER].includes(gd.session.companies.get(gd.companyId).role);
    }

    canEditCustomers() {
        return [CompanyRole.MANAGER].includes(gd.company.role)
    }

    canCreateWorkspace() {
        return [gd.const.company.role.MANAGER, gd.const.company.role.USER].includes(gd.company.role)
    }
};
